// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/opt/buildhome/repo/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from '/opt/buildhome/repo/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import TableOutlined from '/opt/buildhome/repo/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/icons/es/icons/TableOutlined';
export default { SmileOutlined, CrownOutlined, TableOutlined };
